import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiError } from "../lib/api";
import { toast } from "sonner";
import { Trophy } from "lucide-react";

export default function Leaderboard() {
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        (async () => {
            try {
                const { data } = await api.get("/leaderboard");
                setRows(data);
            } catch (e) { toast.error(formatApiError(e)); }
            finally { setLoading(false); }
        })();
    }, []);

    const bgFor = (i) => i === 0 ? "bg-[#FFE55C]" : i === 1 ? "bg-[#FFB8D1]" : i === 2 ? "bg-[#B8E1FF]" : "bg-white";

    return (
        <main className="max-w-2xl mx-auto px-4 py-8">
            <div className="flex items-center gap-3 mb-6">
                <div className="w-11 h-11 rounded-lg brut-static bg-[#FFE55C] flex items-center justify-center">
                    <Trophy className="w-5 h-5" />
                </div>
                <h1 className="display text-3xl sm:text-4xl font-black">Top rated</h1>
            </div>

            {loading ? (
                <div className="font-bold text-[#4A4A4A]">Loading…</div>
            ) : rows.length === 0 ? (
                <div className="border-2 border-dashed border-[#0A0A0A] rounded-xl p-8 text-center bg-white/60" data-testid="leaderboard-empty">
                    <div className="font-black">No rated posts yet.</div>
                    <div className="text-sm text-[#4A4A4A] mt-1 font-medium">Start rating to build the leaderboard.</div>
                </div>
            ) : (
                <div className="space-y-3" data-testid="leaderboard-list">
                    {rows.map((r, i) => (
                        <Link
                            to={`/u/${r.username}`}
                            key={r.user_id}
                            className={`flex items-center gap-4 px-4 py-3 rounded-xl brut-static ${bgFor(i)}`}
                            data-testid={`leaderboard-row-${i}`}
                        >
                            <div className="display text-4xl font-black w-10 text-center">{i + 1}</div>
                            <div className="w-11 h-11 rounded-full bg-white border-2 border-[#0A0A0A] flex items-center justify-center font-black">
                                {r.username[0].toUpperCase()}
                            </div>
                            <div className="flex-1 min-w-0">
                                <div className="font-bold truncate">@{r.username}</div>
                                <div className="text-xs font-medium text-[#4A4A4A]">
                                    {r.posts} post{r.posts === 1 ? "" : "s"} · {r.total_ratings} rating{r.total_ratings === 1 ? "" : "s"}
                                </div>
                            </div>
                            <div className="text-2xl font-black">{r.avg_rating.toFixed(1)}</div>
                        </Link>
                    ))}
                </div>
            )}
        </main>
    );
}
